// const pathname =
//   window.location.origin === "http://localhost:8080"
//     ? "http://localhost"
//     : window.location.origin;

export const API = {
  LOGIN: 'account/login',
  SEND_OTP: 'account/sendOtp',
  FORGOT: 'account/forgot',
  CHANGE: 'account/changePwd',
  GET_ALL_ADMIN_ACCOUNTS: 'account/getAccs',
  ADD_ADMIN: 'account/addAdmin',
  DELETE_ACCOUNT: 'account',
  UPDATE_ACCOUNT: 'account',
  UPDATE_IMAGE: 'account/updateImage',

  INSERT_POST: 'post',
  GET_POST: 'post',
  GET_SINGLE_POST: 'post/single',
  C_AND_T_POST: 'post/cAndT',
  U_AND_T_POST: 'post/uAndT',
  DELETE_POST: 'post',
  UPDATE_POST: 'post',
  SEARCH_POST: 'post/search',
  POST_SORT_POSITION: 'post/sortPositions',
  POST_UPDATE_POSITION: 'post/updatePosition',
  GET_ALL_POST_BY_CAT_GUID: 'post/getByCategory',
  GET_ALL_POST_BY_TAG_NAME: 'post/getByTagDash',

  GET_GODS_DASH: 'god/dash',
  INSERT_GOD: "god",
  GET_SINGLE_GOD: "god/single",
  C_AND_T_GOD: "god/cAndT",
  U_AND_T_GOD: "god/uAndT",
  GET_GOD: "god",
  DELETE_GOD: "god",
  UPDATE_GOD: "god",
  GOD_SORT_POSITION: 'god/sortPositions',
  GOD_UPDATE_POSITION: 'god/updatePosition',

  GET_MUSIC: 'music',
  GET_SINGLE_MUSIC: 'music/single',
  C_AND_T_MUSIC: 'music/cAndT',
  U_AND_T_MUSIC: 'music/uAndT',
  INSERT_MUSIC: 'music',
  DELETE_MUSIC: 'music',
  UPDATE_MUSIC: 'music',
  MUSIC_SORT_POSITION: 'music/sortPositions',
  MUSIC_UPDATE_POSITION: 'music/updatePosition',
  SEARCH_MUSIC: 'music/search',

  UPLOAD_MUSIC: "upload",
  UPLOAD_CSV: "horoscope",
  GET_HOROSCOPE: "horoscope",
  GET_HOROSCOPE_LANGUAGES: "horoscope/newhoroscopelenguages",

  UPLOAD_IMAGE: "upload",

  INSERT_CAT: 'category',
  C_AND_T_CAT: 'category/cAndT',
  GET_CAT: 'category',
  GET_CAT_SINGLE: 'category/single',
  DELETE_CAT: 'category',
  UPDATE_CAT: 'category',
  U_AND_T_CAT: 'category/uAndT',
  SEARCH_CAT: 'category',
  GET_USER_BY_CATEGORY_GUID: 'account/user/get/category',
  GET_ACTIVE_CATEGORY_BY_LANGUAGE: 'category/getActive',
  SORT_POSITION: 'category/sortPositions',
  UPDATE_POSITION: 'category/updatePosition',

  INSERT_EVENT_CAT: "categories",
  GET_EVENT_CAT: "categories/dashFetch",
  GET_SINGLE_EVENT_CAT: "categories",
  C_AND_T_EVENT_CAT: "categories/cAndT",
  U_AND_T_EVENT_CAT: "categories/uAndT",
  DELETE_EVENT_CAT: "categories",
  UPDATE_EVENT_CAT: "categories",
  SEARCH_EVENT_CAT: "categories/c/search",
  GET_ACTIVE_EVENT_CATEGORY_BY_LANGUAGE: "categories",
  FETCH_HINDU_CALENDAR: "hinduCalendar/fetch",

  INSERT_EVENT: "socialevents",
  GET_EVENT: "socialevents",
  DELETE_EVENT: "socialevents",
  UPDATE_EVENT: "socialevents",
  SEARCH_EVENT: "socialevents",
  GET_ACTIVE_EVENT_BY_LANGUAGE: "socialevents",
  SOCIAL_EVENTS: "socialevents",

  INSERT_LANG: 'language',
  GET_LANG: 'language',
  DELETE_LANG: 'language/',
  UPDATE_LANG: 'language/',

  INSERT_TAG: 'tag',
  C_AND_T_TAG: 'tag/cAndT',
  U_AND_T_TAG: 'tag/uAndT',
  GET_TAG: 'tag',
  GET_SINGLE_TAG: 'tag/single',
  DELETE_TAG: 'tag',
  UPDATE_TAG: 'tag',
  SEARCH_TAG: 'tag/search',

  INSERT_APP: 'app',
  GET_APP: 'app',
  GET_APP_BY_GUID: 'app/',
  DELETE_APP: 'app',
  UPDATE_APP: 'app',
  SEARCH_APP: 'app/search',

  INSERT_PROMOTE_APP: 'promotedApp',
  GET_PROMOTE_APP: 'promotedApp',
  DELETE_PROMOTE_APP: 'promotedApp',
  UPDATE_PROMOTE_APP: 'promotedApp',

  UPLOAD_SIGNLE_IMAGE: "upload-single",
  UPLOAD_MULTIPLE_IMAGE: "upload-multiple",
  DELETE_IMAGE: "image/delete",

  INSERT_BANNER: 'banner',
  C_AND_T_BANNER: 'banner/cAndT',
  U_AND_T_BANNER: 'banner/uAndT',
  GET_SINGLE_BANNER: 'banner/single',
  GET_BANNER: 'banner',
  DELETE_BANNER: 'banner',
  UPDATE_BANNER: 'banner',
  SEARCH_BANNER: 'banner/search',
  SORT_BANNER_POSITION: 'banner/sortPositions',
  UPDATE_BANNER_POSITION: 'banner/updatePosition',

  INSERT_WEB_BANNER: 'webBanners',
  GET_WEB_BANNER: 'webBanners',
  GET_SINGLE_WEB_BANNER: 'webBanners/single',
  C_AND_T_WEB_BANNER: 'webBanners/cAndT',
  U_AND_T_WEB_BANNER: 'webBanners/uAndT',
  DELETE_WEB_BANNER: 'webBanners',
  UPDATE_WEB_BANNER: 'webBanners/edit',
  SORT_WEB_BANNER_POSITION: 'webBanners/sortPositions',
  UPDATE_WEB_BANNER_POSITION: 'webBanners/updatePosition',
  // SEARCH_WEB_BANNER: 'webBanners/search',

  GET_SHOP_BANNER: 'shopBanners/dashboard',
  GET_SHOP_BANNER_PLAIN: 'shopBanners',
  GET_SINGLE_SHOP_BANNER: 'shopBanners/single',
  C_AND_T_SHOP_BANNER: 'shopBanners/cAndT',
  U_AND_T_SHOP_BANNER: 'shopBanners/uAndT',
  SORT_SHOP_BANNER_POSITION: 'shopBanners/sort/positions',
  UPDATE_SHOP_BANNER_POSITION: 'shopBanners/updatePosition',

  GET_USERS: "user",
  DELETE_USER: "user",
  UPDATE_USER: "user",
  ADD_USER: "user",

  GET_CONTEST: "contest",
  DELETE_CONTEST: "contest",
  UPDATE_CONTEST: "contest",
  ADD_CONTEST: "contest",

  GET_PARTICIPANT: "participants",
  DELETE_PARTICIPANT: "participants",
  UPDATE_PARTICIPANT: "participants",
  ADD_PARTICIPANT: "participants",

  GET_OFFER: 'offer',
  DELETE_OFFER: 'offer',
  UPDATE_OFFER: 'offer',
  ADD_OFFER: 'offer',
  GET_NOTIFICATION: 'notification',

  ARTICLE_CATEGORY: 'articlecategory',
  ARITCLE_CATEGORY_CANDT: 'articlecategory/cAndT',
  ARTICLE_CATEGORY_UANDT: 'articlecategory/updateAndTranslate',
  ARTICLE_SORT_POSITION: 'articlecategory/sortPositions',
  ARTICLE_UPDATE_POSITION: 'articlecategory/updatePosition',

  ARTICLE: 'article',
  ARTICLE_CANDT: 'article/cAndT',
  ARTICLE_SEARCH: 'article/search',
  UANDT: 'article/updateAndTranslate',
  ARTICLES_SORT_POSITION: 'article/sortPositions',
  ARTICLES_UPDATE_POSITION: 'article/updatePosition',
  ARTICLES_RECENTS: 'article/recent',

  FESTIVAL: 'festival',
  FESTIVAL_C_AND_T: 'festival/cAndT',
  FESTIVAL_U_AND_T: 'festival/uAndT',
  SETTINGS: 'settings',
  EVENT_PARTICIPANT: 'eventparticipant',
  RASHI: 'rashi',

  GET_PAYMENTS: `payments/all`,
  // GET_PAYMENTS_COUNT: `payments/data-count`,

  GET_CONSULT_ASTROLOGY: `consult-astrology/all`,
  GET_CONSULT_ASTROLOGY_COUNT: `consult-astrology/data-count`,

  GET_PROMOTION_DATA: `bhakti/promotion`,
  GET_SINGLE_PROMOTION_DATA: `bhakti/promotion/single`,
  ADD_PROMOTION_DATA: `bhakti/promotion/add`,
  EDIT_PROMOTION_DATA: `bhakti/promotion/edit`,
  DELETE_PROMOTION_DATA: `bhakti/promotion/delete`,
  C_AND_T_PROMOTION_DATA: `bhakti/promotion/cAndT`,
  U_AND_T_PROMOTION_DATA: `bhakti/promotion/uAndT`,

  // notify service
  GET_NOTIFICATIONS: `notifyService`,
  C_AND_T_NOTIFICATION: `notifyService/cAndT`,

  //review service
  GET_REVIEWS: `reviews`,
  HOLIDAYS: `holidaylist`,

  // review storage service
  GET_REVIEWSTR_BY_ID: `reviewStorage`,
  CREATE_JIRA_TICKET: `reviewStorage/create-jira-ticket`,
  MARK_REVIEW_RESOLVED: `reviewStorage/mark-resolved`,
  DELETE_REVIEW: `reviewStorage`,

  PANCHANG_PREDICT: `panchang/predict/monthly`,

  //ai chat
  AI_GET_MESSAGES_UID: 'ai/messages',
  AI_DROP_MESSAGE: 'ai/message',
  AI_GET_LATEST_MESSAGES: 'ai/latestMessages',

  // dashboad metric
  DASHBOARD_METRICS: 'dashboard/metrics',
} 
